import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyShopToggleButtonComponent } from './my-shop-toggle-button.component';



@NgModule({
  declarations: [
    MyShopToggleButtonComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MyShopToggleButtonComponent,
  ]
})
export class MyShopToggleButtonModule { }
